import * as React from 'react';

export interface IModalWindowHeaderProps {
  mode?: modalWindowMode;
  children?: React.ReactNode;
  onClose?: () => void;
}

export type modalWindowMode = 'default' | 'transition';

export const ModalWindowHeader: React.FC<IModalWindowHeaderProps> = (props) => {
  return <>{props.children}</>;
};
